__turbopack_context__.v({
  "container": "ReusableNewsletterSignup-module__da7YiW__container",
  "flushTop": "ReusableNewsletterSignup-module__da7YiW__flushTop",
  "imageWrap": "ReusableNewsletterSignup-module__da7YiW__imageWrap",
});
